type PartialRelationship = { object?: string | null; field?: string | null } | null

export type PartialContactLink = { source?: PartialRelationship; target?: PartialRelationship } | null

export const isCompleteContactLink = (link: PartialContactLink): boolean =>
  !!link?.source?.object && !!link?.source?.field && !!link?.target?.object && !!link?.target?.field

export const isCompleteLinkFor = (link: PartialContactLink, objectName: string): boolean =>
  isCompleteContactLink(link) && (link?.source?.object === objectName || link?.target?.object === objectName)

export const withCompleteContactLinksOnly = <T extends { contactLinks?: PartialContactLink[] | null }>(mapping: T): T =>
  mapping?.contactLinks?.length ? { ...mapping, contactLinks: mapping.contactLinks.filter(isCompleteContactLink) } : mapping
